export default __webpack_public_path__ + "static/media/MyEvent_Carrier.5536f26a.svg";